import React, { Component } from 'react';
// import donorDataCategories from '../../../test/donorDataCategories';
import iScroll from 'iscroll';
import ScrollSpacer from './ScrollSpacer';
import ReactIScroll from 'react-iscroll';
import DonorFullPage from './DonorFullPage';
// import DonorFullPage from '../../Donor/DonorFullPage';
import { isNull } from 'util';
import { connect } from 'react-redux';
import {dp} from '../../../utils/shared.js';
import donorHelpers from '../../../utils/donorHelpers';
import _ from 'lodash';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

class DonorLists extends Component {

  constructor(props) {
    //defaults
    super(props);

    this._subscribeModule = null;
    this._rowWrapperRef = null;
    // this.getSubscribeModule();

    this._columns = 2;
    this._rows = 6;
    this._fontColor = "#ffffff";
    this._backdropColor = "#000000";
    this._footerText = "";
    this._parentCategoryName = ""; //used to stash name so state can switch to empty string
    this._ni_options = {};
    this._metaCycleTimeout = null;
    this._listCycleTime = 8000;
    this._marginRight = this.props.screen.sv.width * 0.0375;
    this._fontClass = 'gfont_roboto';
    this._donorCategories = null;
    this._recognitionOptionsRef = null;
    this._groupSwitched = false;

    this._donorGroups = _.filter(this.props.donors.donorCategories, { parent_category: Number(this.props.module.contents.donor_view_category) });

    // _.forEach(this._donorGroups, group => {
    //   group.donorCategories = _.filter(this.props.donors.donorCategories, { parent_category: group.id });
    // })

    this.state = {
      donorGroup: 0
    };
  }

  componentDidMount() {
    this.renderCategories();
    let recogWidth = this._recognitionOptionsRef.getBoundingClientRect().width;
    this.setState({
      recognitionOffsetX: (this.props.screen.screenWidth - recogWidth) / 2
    });

    if (this._rowWrapperRef) {
			this._rowWrapperRef.addEventListener("tap", () => this.redirect());
		}
  }

  componentDidUpdate() {
    this._groupSwitched = false;
    setTimeout(() => {
      if (this.iScroller) {
        this.iScroller._iScrollInstance.refresh();
      }
    }, 500);
  }

  getBackgroundImage = () => {
    let defaultImg = { path:'/img/miami/general/', file_name:'default_single_screen.jpg' }
    let backgroundObj = _.get(this.props.module, 'contents.images[0]', null);
    return dp(this.props.screen, backgroundObj, defaultImg);
  }

  getIconImage = () => {
    let defaultImg = { path:'/img/miami/general/', file_name:'default_single_screen.jpg' }
    let iconObj = _.get(this.props.module, 'contents.images[2]', null);
    return dp(this.props.screen, iconObj, defaultImg);
  }

  renderCategories = () => {
    let columns = this._columns;
    if (isNull(this._donorCategories)) {
      let categoryWrapStyle = {
        boxSizing: 'border-box',
        width: this.props.screen.screenWidth * 0.78838174273858921162,
        background: "white",
        // height: this.props.screen.r9_16.height * .5,
        paddingBottom: this.props.screen.screenHeight * 0.01875,
        paddingTop: this.props.screen.screenHeight * 0.02893518518518518519,
        borderRadius: 10,
        paddingLeft: this.props.screen.screenWidth * 0.074074074,
        paddingRight: this.props.screen.screenWidth * 0.074074074,
        marginBottom: this.props.screen.screenHeight * 0.03125
      }

      let donorCategories = this.props.module.children[this.state.donorGroup].children;
      let enablePalqueText = _.get(this.props.module.children[this.state.donorGroup], 'contents.custom_fields.enable_palque_text.val', false);
      if (enablePalqueText) {
        columns = 1;
      }
      this._donorCategories = (
        donorCategories.map(function (row, i) {
          const donors = donorHelpers.getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, row.id);
          const sortedDonors = _.orderBy(donors, ['sorting_name'], ['asc']);
          let donorFullPageWidth = this.props.screen.screenWidth * 0.78838174273858921162 - (this.props.screen.screenWidth * 0.074074074 * 2);
          // let height = (Math.ceil(donors.length / this._columns) * this.props.screen.screenHeight * 0.115 / this._rows) + (this.props.screen.screenHeight * 0.021875) + categoryWrapStyle.paddingTop * 2 + categoryWrapStyle.paddingBottom * 2;

          return (
            <div key={i} style={{ display:"flex", alignItems:"center" }}>
              <div style={{ ...categoryWrapStyle }} className='opensans-regular'>
                <div>
                  <h1 className="opensans-semibold" style={{ marginBottom: .00520833333333333333 * this.props.screen.screenHeight, color: "#694f28", fontSize: this.props.screen.screenHeight * 0.021875 }}>{row.name}</h1>
                  <div style={{ backgroundColor: "#694f28", height: .00260416666666666667 * this.props.screen.screenHeight, marginBottom: .01041666666666666667 * this.props.screen.screenHeight }}/>
                </div>
                <div>
                  <DonorFullPage
                    height={this.props.screen.screenHeight * 0.115}
                    width={donorFullPageWidth}
                    columns={columns}
                    rows={this._rows}
                    fontClass={this._fontclass}
                    donorData={sortedDonors}
                    screen={this.props.screen}
                    sort="column"
                    overrideFontSize={0}
                    overrideMarginRight={0}
                    text1={enablePalqueText}
                    custom1x2={'<span />'}>
                  </DonorFullPage>
                </div>
              </div>
            </div>
          )
        }, this)
      )
    }
  }

  switchDonorGroup(groupRef) {
    this._groupSwitched = true;
    this.setState({
      donorGroup: groupRef
    });
    this._donorCategories = null;
  }

  renderGroupInputs() {
    let recognitionOptions = {
      // marginTop: this.props.screen.screenHeight * 0.02604166666666666667
    }

    let recognitionOptionsLabel = {
      width: this.props.screen.screenWidth * 0.18518518518518518519,
      fontSize: this.props.screen.screenWidth * 0.016666667,
    }
    
    switch (this.props.module.children.length) {
      case 1: 
        return (
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"5vh" }}>
            <div className="recognitionOptionsTampa" style={{ ...recognitionOptions }} ref={(recognitionOptionsRef) => this._recognitionOptionsRef = recognitionOptionsRef}>
              <input id="switch_left" name="donorOptions" type="radio" value="cumulative_donors" defaultChecked></input>
              <label onClick={() => this.switchDonorGroup(0)} htmlFor="switch_left" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[0].name.toUpperCase()}</label>
            </div>
          </div>
        )
      case 2:
        return (
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"5vh" }}>
            <div className="recognitionOptionsTampa" style={{ ...recognitionOptions }} ref={(recognitionOptionsRef) => this._recognitionOptionsRef = recognitionOptionsRef}>
              <input id="switch_left" name="donorOptions" type="radio" value="cumulative_donors" defaultChecked></input>
              <label onClick={() => this.switchDonorGroup(0)} htmlFor="switch_left" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[0].name.toUpperCase()}</label>
              <input id="switch_right" name="donorOptions" type="radio" value="campaign_donors"></input>
              <label onClick={() => this.switchDonorGroup(1)} htmlFor="switch_right" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[1].name.toUpperCase()}</label>
            </div>
          </div>
        )
      case 3:
        return (
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"5vh" }}>
            <div className="recognitionOptionsTampa" style={{ ...recognitionOptions }} ref={(recognitionOptionsRef) => this._recognitionOptionsRef = recognitionOptionsRef}>
              <input id="switch_left" name="donorOptions" type="radio" value="cumulative_donors" defaultChecked></input>
              <label onClick={() => this.switchDonorGroup(0)} htmlFor="switch_left" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[0].name.toUpperCase()}</label>
              <input id="switch_middle" name="donorOptions" type="radio" value="middle_donors"></input>
              <label onClick={() => this.switchDonorGroup(1)} htmlFor="switch_middle" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[1].name.toUpperCase()}</label>
              <input id="switch_right" name="donorOptions" type="radio" value="campaign_donors"></input>
              <label onClick={() => this.switchDonorGroup(2)} htmlFor="switch_right" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[2].name.toUpperCase()}</label>
            </div>
          </div>
        )
      case 4:
        return (
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"5vh" }}>
            <div className="recognitionOptionsTampa" style={{ ...recognitionOptions }} ref={(recognitionOptionsRef) => this._recognitionOptionsRef = recognitionOptionsRef}>
              <input id="switch_left" name="donorOptions" type="radio" value="cumulative_donors" defaultChecked></input>
              <label onClick={() => this.switchDonorGroup(0)} htmlFor="switch_left" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[0].name.toUpperCase()}</label>
              <input id="swit ch_middle" name="donorOptions" type="radio" value="middle_donors"></input>
              <label onClick={() => this.switchDonorGroup(1)} htmlFor="switch_middle" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[1].name.toUpperCase()}</label>
              <input id="switch_middle1" name="donorOptions" type="radio" value="middle_donors"></input>
              <label onClick={() => this.switchDonorGroup(2)} htmlFor="switch_middle1" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[2].name.toUpperCase()}</label>
              <input id="switch_right" name="donorOptions" type="radio" value="campaign_donors"></input>
              <label onClick={() => this.switchDonorGroup(3)} htmlFor="switch_right" style={{ ...recognitionOptionsLabel }}>{this.props.module.children[3].name.toUpperCase()}</label>
            </div>
          </div>
        );
      default:
        break;
    }
  }

  render() {
    const background = this.getBackgroundImage();
    const iconImage = this.getIconImage();
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;

    const textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
    const textShadow = `${textShadowSize}px ${textShadowSize}px ${textShadowSize}px black`;

    if (isNull(this._donorCategories)) {
      this.renderCategories();
    }
    const unit = this.props.screen.r9_16.p10;

    return (
      <div>
        <div style={{ position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: backgroundSize, backgroundImage: "url("+background+")" }} >
          <div style={{ display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
            <div style={{ height: "5vw" }} />
            <img alt="Donor Recognition" src={iconImage} style={{ width: '14vh' }} />
          </div>

          <div className="crimson-semi-bold" style={{ textShadow: textShadow, textAlign: "center", fontSize: '4vh', fontWeight:"bold" }}>
            {this.props.module.name}
          </div>
          <div className="crimson-regular" style={{ textShadow: textShadow, fontSize: '2vh', textAlign: "center", paddingRight:"1vh", paddingLeft:"1vh", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" }}>
            {this.props.module.description}
          </div>
          <div className="topgradblackP25" style={{ position:"absolute", width: '100%', height: unit * .25, top:"26.979166667vh" }} />
          <div style={{ height: this.props.screen.screenWidth * .15934065934065934066 }} />

          <div style={{ color: 'black', width: '85%', marginLeft: "auto", marginRight: "auto", touchAction:"none", height: "72.91666666666666666667vh" }}>
            <ReactIScroll key={this.state.groupRef} ref={el => this.iScroller = el} iScroll={iScroll}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.005,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
                tap: true
              }}
              onRefresh={this.initializeIScroll}
            >
              <div style={{ width:"100%", display:"flex", justifyContent:"center" }}>
                <CSSTransitionGroup
                  component='div'
                  transitionName='example'
                  transitionEnterTimeout={0}
                  transitionLeaveTimeout={0}>
                  <div style={{ height: "3vh" }}/>
                  <div>
                    {this.renderGroupInputs()}
                  </div>
                  <div key={this.state.donorGroup}>
                    <div style={{ height:"2.5vh" }}></div>
                    {this._donorCategories}
                    <ScrollSpacer unit={unit} />
                  </div>
                </CSSTransitionGroup>
              </div>
            </ReactIScroll>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    content: state.content,
    donors: state.donors,
  };
};

export default connect(mapStateToProps, null)(DonorLists);



// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/DonorListsTampa.jsx